module.exports = __webpack_public_path__ + "img/IMG_1645_L_WoodMatted_MockedUp.d20766b6.jpg";